<script lang="ts">
    import { Icon } from "sveltestrap";

</script>
<div class="bg-danger text-white px-3 py-2 rounded">
    <small><Icon name="exclamation-diamond-fill" /> Esta respuesta invalida el formulario.</small>
</div>
